import { GumshoeUser } from '@/models';
import { BackgroundCheckProvider, BackgroundReportSearch, NotificationLog } from '@/interfaces';
import { BackgroundCheckReport } from '@/interfaces/BackgroundCheckReport';
import { BuilderVersion } from '@/interfaces/BuildVersion';
import { VolunteerVerification } from '@/interfaces/VolunteerVerification';

export interface State {
  isBusy: boolean;
  dialogOpen: boolean;
  providers: BackgroundCheckProvider[];
  reports: BackgroundReportSearch[];
  reportDetails: BackgroundCheckReport;
  buildVersion: BuilderVersion;
  volunteerVerification: VolunteerVerification;
  verifications: VolunteerVerification[];
  postbackErrorLogs: NotificationLog[];
  postbackErrorLog: NotificationLog;
  currentUser: GumshoeUser;
  selectedUser: GumshoeUser;
  users: GumshoeUser[];
}

export const InitState = {
  isBusy: false,
  dialogOpen: false,
  providers: [],
  reports: [],
  reportDetails: null,
  buildVersion: null,
  volunteerVerification: null,
  verifications: [],
  postbackErrorLogs: [],
  postbackErrorLog: null,
  currentUser: null,
  selectedUser: null,
  users: []
};
